import React from "react";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ListItemButton from "@mui/material/ListItemButton";

import Tracking from "../services/tracking.service";

export function MixPanelTrackedLink({ children, type, gtmEvent, gtmProps = {}, ...props }) {

    const trackButton = (e) => {
        Tracking.trackLink(props.label, type, props.context, gtmEvent, gtmProps);
        props.onClick && props.onClick(e);
    }

    return <React.Fragment>
        {
            type == "button" && <Button
                {...props}
                onClick={trackButton}
            >
                {children}
            </Button>
        }
        {
            type == "link" && <Link
                {...props}
                sx={{ display: 'inline-flex', ...props.sx }}
                href={window.location.pathname == props.href ? null : props.href}
            >
                <Button disableRipple disableTouchRipple color="inherit" onClick={trackButton}
                    {...props.linkButtonProps}
                    sx={{
                        padding: '0 !important',
                        ':hover': {
                            backgroundColor: 'transparent'
                        },
                        ...props.linkButtonProps?.sx
                    }}
                >
                    {children}
                </Button>
            </Link>
        }
        {
            type == 'iconButton' && <IconButton
                {...props}
                onClick={trackButton}
            >
                {children}
            </IconButton>
        }
        {
            type == 'listItemButton' && <ListItemButton
                {...props}
                onClick={trackButton}
            >
                {children}
            </ListItemButton>
        }
        {/* {
            <div {...props}
                onClick={(e) => {
                    Tracking.trackLink(props.label, type, props.context);
                    props.onClick(e);
                }}>
                {children}
            </div>
        } */}

    </React.Fragment>
}